import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_MD, BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { AlbumItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Download } from '../Download';
import { Favorite } from '../Favorite';
import { ItemName } from '../ItemName';
import { Pic } from '../Pic';
import { Album } from '../RowFor/Album';
import { Size } from '../Size';

const AlbumsItem = (props: AlbumItemProps) => {
    const {
        onCheckboxClick,
        isSelected,
        denyDoAction,
        isFolder,
        thumbUrl,
        kind,
        isVirus,
        ext,
        author,
        name,
        favoritesAvailable,
        isInFavorites,
        onFavorites,
        mtime,
        size,
        onDownload,
        id,
        storage,
        isAutoDelete,
    } = props;
    const isProgress = denyDoAction;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Album {...props} checkboxClassname={newStyles.check} favoriteClassname={newStyles.favoriteAction} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} isDisabled={denyDoAction} />
                    <Pic
                        isFolder={isFolder}
                        thumbUrl={thumbUrl}
                        kind={kind}
                        isVirus={!!isVirus}
                        ext={ext || ''}
                        author={author}
                        isAutoDelete={isAutoDelete}
                    />

                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemName name={name} ext={ext || ''} loading={isProgress} id={id} isRenameAvailable={props.renameAvailable} />
                            {!isProgress && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            <Date date={mtime} isWide />
                            <Size size={size} />
                            <Download
                                onClick={onDownload}
                                ext={isFolder ? 'zip' : ext}
                                size={size}
                                id={id}
                                storage={storage}
                                show={!isProgress}
                            />
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <ItemName
                                    name={name}
                                    ext={ext || ''}
                                    loading={isProgress}
                                    id={id}
                                    isRenameAvailable={props.renameAvailable}
                                />
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemName name={name} ext={ext || ''} loading={isProgress} id={id} />

                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} isWide />
                                    </span>
                                </div>
                            )}
                            {!isProgress && windowWidth > BREAKPOINT_MD && (
                                <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} isWide />}
                                    <Size size={size} />
                                </>
                            )}
                            <div className={styles.actionsWrapper}>
                                {!isProgress && windowWidth <= BREAKPOINT_MD && (
                                    <Favorite isAvailable={!!favoritesAvailable} isActive={!!isInFavorites} onClick={onFavorites} />
                                )}
                                <Download
                                    onClick={onDownload}
                                    ext={isFolder ? 'zip' : ext}
                                    size={size}
                                    id={id}
                                    storage={storage}
                                    show={!isProgress}
                                />
                            </div>
                        </>
                    )}
                </>
            }
        />
    );
};

export default AlbumsItem;
